<template>
  <div class="login_page fillcontain">
    <div class="loginTitle">
      <div class="loginTitleImgBox">
        <img v-if="isBeijing" @click="goHome" class="loginTitleImg" src="@/assets/mallLogo2.png" alt />
        <img v-else @click="goHome" class="loginTitleImg" src="@/assets/mallLogo.png" alt />
      </div>
      <div class="loginTitleCenter"></div>
      <div class="loginTitleText">猪产业互联网&nbsp;&nbsp;"智能&nbsp;+&nbsp;生态链"&nbsp;&nbsp;交易平台</div>
    </div>
    <!-- <transition name="form-fade" mode="in-out"> -->
    <div class="imgBgc">
      <img class="imgBgcLeftImg" src="@/assets/loginCenterBgc2.png" alt />
      <section class="form_contianer1" v-show="isLogin">
        <div class="loginTitleContainer">
          <p class="loginTitleContainerLeft">登录</p>
          <span @click="isLogin=!isLogin" class="loginTitleContainerRight">没有账号>>去注册</span>
           <div v-show="warning.show" class="registerWarning">
              <span class='registerWarningIcon'><i class='el-icon-remove'></i></span><span>{{warning.text}}</span>
          </div>
        </div>
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="telephone">
            <el-input ref="telephone"  autocomplete="new-password"  @focus='warningHide' v-model="loginForm.telephone" placeholder="手机号">
               <div class='telephonePrepend' slot="prepend"><i class='el-icon-user'></i></div>
            </el-input>
          </el-form-item>
          <el-form-item prop="passWord" v-if="!verificationCode">
            <el-input
              autocomplete="new-password"
              @focus='warningHide'
              ref="passWord"
              type="passWord"
              :show-password="true"
              placeholder="密码"
              v-model="loginForm.passWord"
            >
            <div class='passWordPrepend' slot='prepend'><i class='el-icon-lock'></i></div>
            </el-input>
          </el-form-item>
          <el-form-item prop="verificationCode" v-if="verificationCode">
            <el-input
              ref="VerificationCode"
              v-model="loginForm.VerificationCode"
            >
            <el-button class='VerificationCodePrepend' slot='append' :disabled="!show" @click="getVerificationCode">
              获取验证码
              <span v-show="!show" class="count">{{count}} s</span>
            </el-button>
            </el-input>
            
          </el-form-item>

          <div class="forgetPassword">
            <span @click='toHome' class="forgetPw1 textHover">去首页</span>
            <p>
              <span  @click='resetLoginPwd'   class="textHover forgetPw1">忘记密码?</span>
              <span  @click='verificationCodeShow'   class="textHover forgetPw1">{{verificationCode ? "密码登录" : "短信验证码登录"}}</span>
            </p>
            
          </div>
          <el-form-item>
            <el-button
              type="danger"
              native-type="button"
              :loading="loginLoading"
              @click="submitForm('loginForm')"
              class="submit_btn"
            >
              <span v-html="msg"></span>
            </el-button>
          </el-form-item>
        </el-form>
      </section>

      <section class="form_contianer_register" v-show="!isLogin">
        <div class="loginTitleContainer">
          <p class="loginTitleContainerLeft">注册</p>
          <span @click="isLogin=!isLogin" class="loginTitleContainerRight">已有账号>>去登录</span>
          <div v-show="warning.show" class="registerWarning">
              <span class='registerWarningIcon'><i class='el-icon-remove'></i></span><span>{{warning.text}}</span>
          </div>
        </div>

        <el-form :model="registerForm" :rules="rules" ref="registerForm">
          <el-form-item prop="telephone">
            <el-input ref="telephone"   autocomplete="new-password" @focus='warningHide' v-model="registerForm.telephone" placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item prop="passWord">
            <el-input
              ref="passWord"
               autocomplete="new-password"
              type="passWord"
              :show-password="true"
              placeholder="6-20位数字与字母组合密码"
               @focus='warningHide'
              v-model="registerForm.passWord"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="secondPassword">
            <el-input
              ref="secondPassword"
              type="passWord"
               autocomplete="new-password"
              :show-password="true"
              placeholder="确认密码"
               @focus='warningHide'
              v-model="registerForm.secondPassword"
            ></el-input>
          </el-form-item>

          <el-form-item prop="code">
            <div class="codeContainer">
              <div class="codeItem">
                <el-input ref="code"  @focus='warningHide' placeholder="验证码" v-model="registerForm.code"></el-input>
              </div>
              <div class="sendCodeButton">
                <el-button
                  type="danger"
                  size="samll"
                  @click="sendcode"
                  :disabled="sendDisabled"
                >{{sendText}}</el-button>
              </div>
            </div>
          </el-form-item>
          <div class="tips">
            点击'注册'代表您同意准守
            <span @click="clickAgreements(1)" class="agreenments">服务条款</span>、
            <span @click="clickAgreements(2)" class="agreenments">联动支付服务协议</span>、
            <span @click="clickAgreements(3)" class="agreenments">认证授权</span>、
            <span @click="clickAgreements(4)" class="agreenments">隐私政策条款</span>、
            <span @click="clickAgreements(5)" class="agreenments">注册协议</span>。
          </div>
          <el-form-item>
            <el-button
              type="danger"
              native-type="button"
              :loading="loginLoading"
              @click="submitForm('registerForm')"
              class="submit_btn"
            >
              <span v-html="msgRegister"></span>
            </el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="fotter">Copyright&copy;&nbsp;2019&nbsp;{{isBeijing?`北京中农亿家资源科技有限公司`:`湖南省中农亿家资源科技有限公司`}}版权所有</div>
    <!-- tips弹出框 -->
    <el-dialog :visible.sync="tipsDialogVisible" width="50vw" height="700">
      <Tips :type="agreenmentType"></Tips>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { login, sendCodeMessageUrl, registerUrl,isBeijing,loginWithCodeUrl} from "@/api/api";
import Tips from "@/components/Tips";
export default {
  data() {
    return {
      isBeijing:'',
      warning: {
        show: false,
        text: ""
      },
      show: true,
      count: '',
      timer: null,
      msg: "登 录",
      msgRegister: "注 册",
      loginForm: {
        telephone: "",
        passWord: "",
        VerificationCode:''
      },
      registerForm: {
        telephone: "",
        passWord: "",
        secondPassword: "",
        code: "",
        checked: ""
      },
      timeOut: 120,
      sendText: "获取验证码",
      sendDisabled: false,
      btntxt: "1111",
      rules: {
        username: [{ message: "请输入手机号", trigger: "blur" }],
        passWord: [{ message: "请输入密码", trigger: "blur" }],
        verificationCode: [{ message: "请输入验证码", trigger: "blur" }]
      },
      verificationCode:true,
      isLogin: true,
      loginLoading: false,
      tipsDialogVisible: false,
      agreenmentType: ""
    };
  },
  components: {
    Tips
  },
  mounted() {
    this.isBeijing = isBeijing
  },
  // beforeRouteEnter(to,from,next){

  //     next((vm)=>{

  //       (window.localStorage.getItem('vuex'))&&vm.$router.push('buyOrder')
  //     })

  // },
  computed: {
    ...mapState(["userInfo", "loginInfo"])
  },
  watch: {
    isLogin() {
      let warning = {
        show: false,
        text: ""
      };
      this.warning = warning;
    }
  },
  methods: {
    ...mapMutations(["saveUserInfo", "saveCompanyInfo", "setLoginInfo"]),
    resetLoginPwd(){
      this.$router.push({name:"settingPage",query:{
        type:"resetLoginPwd"
      }})
    },
    toHome(){
      this.$router.push('/')
    },
    testLogin() {
      let { telephone, passWord } = this.loginForm;
      if (!telephone.trim()) {
        let warning = {
          show: true,
          text: "手机号不能为空"
        };
        this.warning = warning;
        console.log(1);
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(telephone.trim())) {
        let warning = {
          show: true,
          text: "请填写有效的手机号"
        };
        this.warning = warning;

        console.log(2);
        return false;
      }

      if ((!passWord.trim()) && !this.verificationCode) {
        let warning = {
          show: true,
          text: "密码不能为空"
        };
        console.log("2")
        this.warning = warning;

        return false;
      }
      return true;
    },
    
    verificationCodeShow(){
      if(this.verificationCode){
        this.verificationCode=false;
      }else{
        this.verificationCode=true;
      }
      
    },
    login(info) {
      if (info || this.testLogin()) {
        let that = this;
        that.msg = "登陆中";
        that.loginLoading = true;
        let data = null;
        let url = login + "?_date=" + new Date().getTime();
        if (info) {
          data = info;
        } else {
          data = {
            telephone: this.loginForm.telephone,
            passWord: this.$md5("" + that.loginForm.passWord)
          };
        }

        data.type = 0;

        console.log("login", login);
        let param = new URLSearchParams();

        for (var k in data) {
          param.append(k, data[k]);
        }

        this.$axios({ method: "post", data: param, url })
          .then(res => {
            if (res.data.resultCode == 0) {
              let warning = {
                show: true,
                text: "账号或密码有误"
              };
              this.warning = warning;
              that.loginLoading = false;
              that.msg = "登陆";
            } else if (res.data.resultCode == 1) {
              that.saveUserInfo(res.data.data);
              that.saveCompanyInfo(res.data.data2);
              console.log("账号密码正确", res.data.data);
              console.log("用户其他信息", res.data.data2);

              that.loginForm.telephone = "";
              that.loginForm.passWord = "";
              //that.$router.push('')
              // that.$router.push({ path: '/manage', query: {  key: value,key: value  } })
              // console.log(that.$router)
              console.log("that.loginInfo", that.loginInfo);
              if (that.loginInfo) {
                let { name, query } = that.loginInfo;
                that.$router.push({ name, query });
                that.setLoginInfo(null);
              } else {
                that.$router.push("/");
              }
            }
          })
          .catch(function(error) {
            let warning = {
              show: true,
              text: "登录失败，失败原因:" + error
            };
            this.warning = warning;
            that.loginLoading = false;
            that.msg = "登陆";
          });
      }
    },
    register() {

      if (this.testRegister()) {
        let that = this;
        that.msgRegister = "注册中";
        that.loginLoading = true;
        let data = null;
        let url = registerUrl;

        data = {
          telephone: this.registerForm.telephone,
          passWord: this.$md5("" + that.registerForm.passWord),
          code: this.registerForm.code.trim()
        };

        console.log("login", login);
        let param = new URLSearchParams();

        for (var k in data) {
          param.append(k, data[k]);
        }

        this.$axios({ method: "post", data: param, url })
          .then(function(res) {
            if (res.data.resultCode == 1) {
              that.loginLoading = false;
              that.msg = "注册";
              that.$alert("注册成功", "提示", {
                confirmButtonText: "确定",
                callback: action => {
                  that.login({
                    telephone: that.registerForm.telephone,
                    passWord: that.$md5(""+that.registerForm.passWord)
                  });
                }
              });
            } else {
              that.$alert(`${res.data.resultMsg}`, "提示", {
                confirmButtonText: "确定"
              });
            }
          })
          .catch(function(error) {
            that.$alert("登录失败，失败原因:" + error, "提示", {
              confirmButtonText: "确定",
              callback: action => {
                that.loginLoading = false;
                that.msg = "登陆";
              }
            });
          });
      }
    },
    warningHide(){
      let warning = JSON.parse(JSON.stringify(this.warning))
      warning.show = false
      this.warning = warning
    },
    submitForm() {
      if (!/^1[3456789]\d{9}$/.test(this.loginForm.telephone.trim())) {
        let warning = {
          show: true,
          text: "请填写有效的手机号"
        };
        this.warning = warning;

        console.log(2);
        return false;
      }
      if((!this.loginForm.VerificationCode.trim()) && (this.verificationCode)){
        let warning = {
          show: true,
          text: "验证码不能为空"
        };
        console.log("2222")
        this.warning = warning;
      }else{
        if(this.verificationCode){
        let that = this;
        that.msg = "登陆中";
        that.loginLoading = true;
        let url = loginWithCodeUrl;
        let data = {
            // access_token: this.userInfo.access_token,
            telephone:this.loginForm.telephone,
            code:this.loginForm.VerificationCode,
        };
        let param = new URLSearchParams();
        for (var k in data) {
            param.append(k, data[k]);
        }
        this.$axios({
            method: "post",
            data: param,
            url,
        })
        .then((res) => {
        console.log(res);
        if (res.data.resultCode == 1) {
            let { data } = res.data;
            that.saveUserInfo(res.data.data);
            that.saveCompanyInfo(res.data.data2);
            console.log("账号密码正确", res.data.data);
            console.log("用户其他信息", res.data.data2);
            
            that.loginForm.telephone = "";
            that.loginForm.VerificationCode = "";
            console.log("that.loginInfo", that.loginInfo);
            if (that.loginInfo) {
              let { name, query } = that.loginInfo;
              that.$router.push({ name, query });
              that.setLoginInfo(null);
              that.msg = "登录";
              that.loginLoading = false;
            } else {
              that.msg = "登录";
              that.loginLoading = false;
              that.$router.push("/");
              // this.$alert("测试错误");
            }
            
        } 
        else {
          this.$alert("验证码错误");
          that.msg = "登录";
          that.loginLoading = false;
        }
        })
        .catch((err) => {
        this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });
      }else{
          if (this.isLogin) {
          this.login();
        } else {
          this.register();
        }
      }
      }
      
      
    },
    testRegister() {
      let {
        telephone,
        passWord,
        secondPassword,
        code,
        checked
      } = this.registerForm;
      if (!telephone.trim()) {
        let warning = {
          show: true,
          text: "手机号不能为空"
        };
        this.warning = warning;
        console.log(1);
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(telephone.trim())) {
        let warning = {
          show: true,
          text: "请填写有效的手机号"
        };
        this.warning = warning;
        console.log(2);
        return false;
      }

      if ((!passWord.trim())&&this.verificationCode) {
        console.log(3);

        let warning = {
          show: true,
          text: "密码不能为空"
        };
        console.log('333')
        this.warning = warning;
        return false;
      }
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(passWord)) {
        let warning = {
          show: true,
          text: "密码应为6-20位字母与数字组合"
        };
        this.warning = warning;
        return false;
      }
      if (passWord != secondPassword) {
        let warning = {
          show: true,
          text: "两次输入密码不一致"
        };
        this.warning = warning;
        return false;
      }

      if (!code.trim()) {
        let warning = {
          show: true,
          text: "验证码不能为空"
        };
        this.warning = warning;

        return false;
      }
      return true;
    },
    testSendCode() {
      let {
        telephone,
        passWord,
        secondPassword,
        code,
        checked
      } = this.registerForm;
      if (!telephone.trim()) {
        let warning = {
          show: true,
          text: "手机号不能为空"
        };
        this.warning = warning;

        console.log(1);
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(telephone.trim())) {
        let warning = {
          show: true,
          text: "请填写有效的手机号"
        };
        this.warning = warning;
        console.log(2);
        return false;
      }

      if (!passWord.trim()) {
        console.log(3);
        let warning = {
          show: true,
          text: "密码不能为空"
        };
        console.log('qweeqe')
        this.warning = warning;

        return false;
      }
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(passWord)) {
        let warning = {
          show: true,
          text: "密码应为6-20位字母与数字组合"
        };
        this.warning = warning;
        return false;
      }
      if (passWord != secondPassword) {
        let warning = {
          show: true,
          text: "两次输入密码不一致"
        };
        this.warning = warning;
        console.log(1);
        return false;
      }
      return true;
    },
    clickAgreements(type) {
      this.agreenmentType = type;
      this.tipsDialogVisible = true;
    },
    setType() {
      this.isLogin = !this.$route.query.isRegister;
    },
    countDown() {
      this.sendDisabled = true;
      this.timeOut--;
      this.sendText = this.timeOut + "s";
      var setInter = setInterval(() => {
        this.timeOut--;
        this.sendText = this.timeOut + "s";
        if (this.timeOut <= 0) {
          this.sendDisabled = false;
          clearInterval(setInter);
          this.sendText = "获取验证码";
        }
      }, 1000);
    },
    goHome() {
      this.$router.push("/");
    },
    getVerificationCode(){
      // console.log('AAAAAAAAAAAAA');
      // const TIME_COUNT = 300;
      // if (!this.timer) {
      //   this.count = TIME_COUNT;
      //   this.show = false;
      //   this.timer = setInterval(() => {
      //     if (this.count > 0 && this.count <= TIME_COUNT) {
      //       this.count--;
      //     } else {
      //       this.show = true;
      //       clearInterval(this.timer);
      //       this.timer = null;
      //     }
      //   }, 1000)
      // }
      if (!this.loginForm.telephone.trim()) {
        let warning = {
          show: true,
          text: "手机号不能为空"
        };
        this.warning = warning;
        console.log(1);
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.loginForm.telephone.trim())) {
        let warning = {
          show: true,
          text: "请填写有效的手机号"
        };
        this.warning = warning;

        console.log(2);
        return false;
      }
        if(this.loginForm.telephone.trim()!=""){
            let url = sendCodeMessageUrl;
            let data = {
                type:3,
                telephone:this.loginForm.telephone,
            };
            let param = new URLSearchParams();
            for (var k in data) {
                param.append(k, data[k]);
            }
            this.$axios({
                method: "post",
                data: param,
                url,
            })
            .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
                let { data } = res.data;
                // console.log("dataf", data);
                this.invoiceList=data;
                const TIME_COUNT = 300;
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.show = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000)
                }
                this.loading=false;
            } else {
                this.$alert(res.data.resultMsg);
            }
            })
            .catch((err) => {
            this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
            });
        }else{
          this.$alert("请输入手机号");
        }
        
    },
    sendcode() {
      if (this.testSendCode()) {
        let url = sendCodeMessageUrl;
        let data = {
          telephone: this.registerForm.telephone,
          type: 1
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,

          url
        })
          .then(res => {
            console.log(res);
            if (res.data.resultCode == 1) {
              this.countDown();
            } else {
              this.$alert(res.data.resultMsg);
            }
          })
          .catch(err => {
            alert(err.msg);
          });
      }
    }
  },

  created: function() {
    this.setType();
    // 主页添加键盘事件,注意,不能直接在焦点事件上添加回车
    var that = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
        that.submitForm();
        return false;
      }
    };
  },
  destroyed: function() {
    document.onkeydown = null;
  }
};
</script>

<style lang="less" scoped>
@import "../style/mixin";
.login_page {
  background-color: #f6f6f6;
  height: 100vh;
}
.fillcontain {
  /* // background-image: url(../assets/img/login_bgc.png);
  // background-repeat: no-repeat; */
  display: flex;
  flex-direction: column;
}
.manage_tip {
  position: absolute;
  width: 100%;
  top: -100px;
  left: 0;
  p {
    font-size: 34px;
    color: #fff;
  }
}
.loginTitleContainer {
  position: relative;
  height: 30px;
  display: flex;
  justify-content: space-between;
  /* // background-color: red; */
  align-items: center;
  margin-bottom: 30px;
}

.form_contianer1 {
  .wh(320px, 255px);
  .ctp(320px, 235px);

  padding: 25px;
  border-radius: 5px;
  text-align: center;
  background-color: #fff;
  .submit_btn {
    width: 100%;
    font-size: 16px;
  }
}
.forgetText{
  text-decoration: underline;
}
.form_contianer_register {
  .wh(320px, 370px);
  .ctp(320px, 290px);
  padding: 25px;
  border-radius: 5px;
  text-align: center;
  background-color: #fff;
  .submit_btn {
    width: 100%;
    font-size: 16px;
  }
}
.tip {
  font-size: 12px;
  color: red;
}
.form-fade-enter-active,
.form-fade-leave-active {
  transition: all 1s;
}
.form-fade-enter,
.form-fade-leave-active {
  transform: translate3d(0, -50px, 0);
  opacity: 0;
}
.loginTitleContainerLeft {
  font-size: 18px;
  color: #333;
}
.loginTitleContainerRight {
  font-size: 14px;
  color: #666;
}
.loginTitleContainerRight:hover {
  cursor: pointer;
  color: red;
  margin-top: 1px;
}
.forgetPassword {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: -15px;
  font-size: 12px;
  color: #666;
}
.forgetPassword p{
  display: inline-block;
}
.form_contianer_register .el-form-item {
  margin-bottom: 10px;
}
.codeItem {
  flex: 1;
  margin-right: 10px;
}
.sendCodeButton {
}
.codeContainer {
  display: flex;
  align-items: center;
  /* // background-color: red; */
  width: 100%;
}
.agreenments {
  text-decoration: underline;
  color: #333;
}
.agreenments:hover {
  cursor: pointer;
}
.tips {
  font-size: 12px;
  color: #666;
  text-align: left;
  margin-bottom: 20px;
}
.loginTitle {
  /* // background-color: #f6f6f6; */
  height: 100px;
  display: flex;
  align-items: center;
  position: relative;
  left: 20vw;
}
.loginTitleImg {
  height: 100px;
}
.loginTitleImg:hover {
  cursor: pointer;
}
.loginTitleText {
  font-size: 16px;
  color: #333;
}
.loginTitleCenter {
  height: 50px;
  width: 1px;
  background-color: #aaa;
  margin-left: 10px;
  margin-right: 20px;
}
.loginTitleImgBox {
}
.imgBgc {
  width: 100%;
  flex: 1;
  background-image: url("../assets/loginCenterBgc.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.fotter {
  height: 100px;
  text-align: center;
  color: #666;
  font-size: 14px;
}
.imgBgcLeftImg {
  min-width: 400px;
}
.forgetPw1 {
  /* flex: 3; */
  text-decoration: underline;
  font-size: 12px;
  margin-left: 5px;
}
.warning {
  font-size: 14px;
  color: #f40;
}
.warningBox {
}
.registerWarning {
  height: 25px;
  text-align: left;
  font-size: 12px;
  background-color: #fef2f2;
  border: 1px solid #ffb4a8;
  margin-bottom: 10px;
  position: absolute;
  bottom: -35px;
  width: 100%;
  display: flex;
  align-items: center;
  color:#666
}
.telephonePrepend{
  font-size: 16px;
}
.passWordPrepend{
   font-size: 16px;
   
}

.registerWarningIcon{
  color:#f40;
  margin:0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue